import { z } from 'zod';

export const roadmapDTOSchema = z.object({
  roadmapId: z.number().int(),
  organizationId: z.string().min(1),
  name: z.string().min(1).max(64),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type RoadmapDTO = z.infer<typeof roadmapDTOSchema>;

export const roadmapInsertDTOSchema = z
  .object({
    name: z.string().min(1).max(64),
  })
  .strict();

export const roadmapUpdateDTOSchema = z
  .object({
    name: z.string().min(1).max(64).optional(),
  })
  .strict();

export type RoadmapInsertDTO = z.infer<typeof roadmapInsertDTOSchema>;
export type RoadmapUpdateDTO = z.infer<typeof roadmapUpdateDTOSchema>;
